import React from "react";
import TextInput from "../../components/TextInput/TextInput";
import TextAreaInput from "../../components/TextAreaInput/TextAreaInput";
import { FieldType } from "../../../../../shared/types";
const TextField = ({
  isError,
  useFormProps,
  field,
  text,
  wuiltContext
}) => {
  const {
    min,
    max,
    minLength,
    maxLength
  } = field?.settings || {};
  const Component = field?.type === FieldType.TextArea ? TextAreaInput : TextInput;
  return /*#__PURE__*/React.createElement(Component, {
    id: field?.id,
    isError: isError,
    fieldSettings: field?.settings || {},
    text: text,
    wuiltContext: wuiltContext,
    registerProps: {
      ...useFormProps?.register(field?.id, {
        max,
        min,
        maxLength,
        minLength
      })
    }
  });
};
export default TextField;
//# sourceMappingURL=TextField.js.map